import { render, staticRenderFns } from "./EditPublications.vue?vue&type=template&id=7809029a&scoped=true"
import script from "./EditPublications.vue?vue&type=script&lang=js"
export * from "./EditPublications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7809029a",
  null
  
)

export default component.exports